import styled from 'styled-components'
import {ComponentProps} from "react";

interface BaseProps {
	primary?: boolean,
	outline?: boolean,
	wrap?: boolean,
}

const StyledButton = styled.button<BaseProps>`
    position: relative;
    cursor: pointer;
    font-weight: 600;
    text-transform: capitalize;
    color: #FFF;
    background-color: #525C7D;
    background-color: rgba(82, 92, 125, 0.5);
    border: none;
    border-radius: 5px;
    width: 150px;
    margin: 10px;
    max-width: calc(100% - 20px);
    padding: 15px 10px;

    &:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: inherit;
    }

    ${({primary}) => primary && `
    background-color: transparent;
    background-image: var(--ggButtonLinearGradient);
  `}
    ${({outline}) => outline && `
    background-color: transparent;
    
    &:after {
      border: 2px solid rgba(82, 92, 125, 0.5);
    }
  `}
    ${({wrap}) => wrap ? '' : `
    white-space: nowrap;
    width: auto;
  `}
    &:hover {
        filter: brightness(0.9);
    }
`

export const Button = ({
	                       primary = false,
	                       outline = false,
	                       wrap = true,
	                       children,
	                       ...props
                       }: ComponentProps<'button'> & BaseProps) =>
	<StyledButton
		primary={primary}
		outline={outline}
		wrap={wrap}
		{...props}>
		{children}
	</StyledButton>
